import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import spacing from '../../styles/lib/spacing';

import { containerBPStyles, getStyleProp, parseGridTemplateColumns } from './utils';
import propTypes from './propTypes';

const Container = styled.div`
  display: grid;
  max-width: ${p => getStyleProp(p, 'maxWidth')};
  padding: ${p => getStyleProp(p, 'padding')};
  margin-right: ${p => getStyleProp(p, 'marginRight')};
  margin-left: ${p => getStyleProp(p, 'marginLeft')};
  grid-gap: ${p => getStyleProp(p, 'gap')};
  grid-auto-flow: ${p => getStyleProp(p, 'gridAutoFlow')};
  grid-auto-rows: ${p => getStyleProp(p, 'gridAutoRows')};
  grid-auto-columns: ${p => getStyleProp(p, 'gridAutoColumns')};
  grid-template-rows: ${p => getStyleProp(p, 'gridTemplateRows')};
  grid-template-columns: ${p =>
    parseGridTemplateColumns(
      getStyleProp(p, 'columns'),
      getStyleProp(p, 'gridTemplateColumns')
    )};
  align-content: ${p => getStyleProp(p, 'alignContent')};
  align-items: ${p => getStyleProp(p, 'alignItems')};
  justify-content: ${p => getStyleProp(p, 'justifyContent')};
  justify-items: ${p => getStyleProp(p, 'justifyItems')};
  ${containerBPStyles}
`;

const ContainerComponent = props => <Container {...props} />;

ContainerComponent.propTypes = {
  /** Spacing between items */
  gap: propTypes.gap,

  /** Declare a column template */
  gridTemplateColumns: propTypes.gridTemplateColumns,

  /** Declare a row template */
  gridTemplateRows: propTypes.gridTemplateRows,

  /** Controls how the auto-placement algorithm works. */
  gridAutoFlow: propTypes.gridAutoFlow,

  /** Specifies the size of any auto-generated row tracks */
  gridAutoRows: propTypes.gridAutoRows,

  /** Specifies the size of any auto-generated column tracks */
  gridAutoColumns: propTypes.gridAutoColumns,

  /** Controls the alignment of grid on the Column Axis of the grid area */
  alignContent: propTypes.alignContent,

  /** Controls the alignment of items on the Column Axis within their grid area */
  alignItems: propTypes.alignItems,

  /** Controls the alignment of items on the Row Axis within their grid area */
  justifyItems: propTypes.justifyItems,

  /** Controls the alignment of grid on the Row Axis of their grid area */
  justifyContent: propTypes.justifyContent,

  /** Amount of columns the container should hold  -- overrides gridTemplateColumns */
  columns: PropTypes.number,

  /** What is the maximum width the grid should occupy */
  maxWidth: propTypes.maxWidth,

  /** Internal padding, expects 1 to 4 values */
  padding: propTypes.padding,

  /** Essentially a fall back if no other props are passed */
  inherent: propTypes.containerInherent.isRequired,
};

ContainerComponent.defaultProps = {
  inherent: {
    gridTemplateRows: '1fr',
    gridTemplateColumns: '1fr',
    gridAutoFlow: 'row',
    gridAutoRows: 'auto',
    gridAutoColumns: '1fr',
    maxWidth: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    gap: spacing.medium,
  },
};

// Export styled-component, and react component to preserve PropType peeking
export { Container };
export default ContainerComponent;
